import React, { useEffect, useState } from 'react';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 0,
    minutes: 10,
    seconds: 0
  });
  useEffect(() => {
    const targetDate = new Date();
    targetDate.setMinutes(targetDate.getMinutes() + 10);
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;
      if (distance < 0) {
        clearInterval(timer);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex gap-2 items-center justify-center" role="timer" aria-live="polite" data-id="element-55">
      <div className="flex flex-col items-center bg-pink-600 rounded-lg px-3 py-2 min-w-[60px] animate-shake" data-id="element-56">
        <span className="text-2xl md:text-3xl font-extrabold text-white leading-none" data-id="element-57">
          {String(timeLeft.hours).padStart(2, '0')}
        </span>
        <span className="text-xs text-pink-100 font-bold uppercase" data-id="element-58">Horas</span>
      </div>
      <span className="text-2xl md:text-3xl font-extrabold text-pink-600 animate-flash" data-id="element-59">
        :
      </span>
      <div className="flex flex-col items-center bg-pink-600 rounded-lg px-3 py-2 min-w-[60px] animate-shake" data-id="element-60">
        <span className="text-2xl md:text-3xl font-extrabold text-white leading-none" data-id="element-61">
          {String(timeLeft.minutes).padStart(2, '0')}
        </span>
        <span className="text-xs text-pink-100 font-bold uppercase" data-id="element-62">Min</span>
      </div>
      <span className="text-2xl md:text-3xl font-extrabold text-pink-600 animate-flash" data-id="element-63">
        :
      </span>
      <div className="flex flex-col items-center bg-pink-600 rounded-lg px-3 py-2 min-w-[60px] animate-shake" data-id="element-64">
        <span className="text-2xl md:text-3xl font-extrabold text-white leading-none" data-id="element-65">
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
        <span className="text-xs text-pink-100 font-bold uppercase" data-id="element-66">Seg</span>
      </div>
    </div>;
}